import { useRouter } from 'next/router';

export const useValidLocale = () => {
  const { locale } = useRouter();
  if (locale?.includes('_')) {
    return locale.replace('_', '-');
  }
  return locale;
};
